<div class="wrapper d-flex flex-column">
    <div *ngIf="form?.touched && form?.errors?.min" class="mb-1">
        <span class="font-small color-error">{{'FORM.GENERIC_ERRORS.MIN' | translate:form?.errors?.min}}</span>
    </div>
    <div *ngIf="form?.touched && form?.errors?.max" class="mb-1">
        <span class="font-small color-error">{{'FORM.GENERIC_ERRORS.MAX' | translate:form?.errors?.max}}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.required" class="mb-1">
        <span class="font-small color-error">{{'FORM.GENERIC_ERRORS.REQUIRED' | translate}}</span>
    </div>
    <div *ngIf="form?.touched && form?.errors?.validateEmptyArray" class="mb-1">
        <span class="font-small color-error">{{'FORM.GENERIC_ERRORS.REQUIRED' | translate}}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.requiredTrue" class="mb-1">
        <span class="font-small color-error">{{'FORM.GENERIC_ERRORS.REQUIREDTRUE' | translate}}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.email" class="mb-1">
        <span class="font-small color-error">{{'FORM.GENERIC_ERRORS.EMAIL' | translate}}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.minlength" class="mb-1">
        <span
            class="font-small color-error">{{'FORM.GENERIC_ERRORS.MINLENGTH' | translate:form?.errors?.minlength}}</span>
    </div>
    <div *ngIf="form?.touched && form?.errors?.maxlength" class="mb-1">
        <span
            class="font-small color-error">{{'FORM.GENERIC_ERRORS.MAXLENGTH' | translate:form?.errors?.maxlength}}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.pattern" class="mb-1">
        <span class="font-small color-error">{{'FORM.GENERIC_ERRORS.PATTERN' | translate}}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.validateOnlyNumber" class="mb-1">
        <span class="font-small color-error">{{'FORM.GENERIC_ERRORS.NUMBER' | translate}}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.validatePattern" class="mb-1">
        <span class="font-small color-error">{{ form?.errors?.message | translate }}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.validateMaxCoverage" class="mb-1">
        <span class="font-small color-error">{{ form?.errors?.message | translate }}</span>
    </div>

    <div *ngIf="form?.touched && form?.errors?.validateWorksDates" class="mb-1">
        <span class="font-small color-error">{{ 'FORM.GENERIC_ERRORS.DATES' | translate }}</span>
    </div>
    <div *ngIf="form?.touched && form?.errors?.validateEmail" class="mb-1">
        <span class="font-small color-error">{{ 'FORM.GENERIC_ERRORS.EMAIL' | translate }}</span>
    </div>
    <div *ngIf="form?.touched && form?.errors?.validateAssignedHours" class="mb-1">
        <span class="font-small color-error">{{ 'FORM.GENERIC_ERRORS.ASSIGNED_HOURS' | translate }}</span>
    </div>
    <div *ngIf="form?.touched && form?.errors?.validateJobProcess" class="mb-1">
        <span
            class="font-small color-error">{{ 'FORM.GENERIC_ERRORS.VALORATE_REQUIRED_RECOMMENDATION' | translate }}</span>
    </div>
</div>